module.exports = __webpack_public_path__ + "img/Incorrect Assembly.560aa834.png";